/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-prototype-builtins */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Instance, types } from "mobx-state-tree";
import { withSetPropAction } from "./helpers/withSetPropAction";
import { validateCardNo, validateExpiryDate, validateCVV } from "@/app/csr-src/utils/validatorsUtils";
import { BNP_BANK_STR, BNP_BANK_TYPE } from "@/app/csr-src/apis/checkout/constants/constants";

// 信用卡结构
const ICreditCardVo = types.model("CreditCardVo", {
  cardNo: types.string,
  expireDateMonth: types.string,
  expireDateYear: types.string,
  cvv: types.string,
});
const IBnpCreditCardVo = types.model("BnpCreditCardVo", {
  brand: types.string,
  number: types.string,
  expiryDate: types.string,
  securityCode: types.string,
  MerchantID: types.string,
  Data: types.string,
  Len: types.number,
  actionUrl: types.string,
  cardHolderName: types.string,
});

export const CreditCardStoreModel = types
  .model("CreditCardStore")
  .props({
    // 信用卡表单
    creditCardForm: types.optional(ICreditCardVo, {
      cardNo: "",
      expireDateMonth: "",
      expireDateYear: "",
      cvv: "",
    }),
    // 信用卡表单验证
    creditCardValid: types.optional(ICreditCardVo, {
      cardNo: "",
      expireDateMonth: "",
      expireDateYear: "",
      cvv: "",
    }),
    // bnp信用卡提交表单
    bnpCreditCardSubmitForm: types.optional(IBnpCreditCardVo, {
      brand: "visa",
      number: "",
      expiryDate: "",
      securityCode: "",
      MerchantID: "",
      Data: "",
      cardHolderName: "",
      Len: 0,
      actionUrl: "https://paymentpage.axepta.bnpparibas/payNow.aspx",
    }),
    billingAddress: types.optional(types.frozen({}), {}),
  })
  .views((self) => ({
    // 信用卡是否使用pay now的方式支付
    get isPayNow() {
      return true;
    },
    // 信用卡表单是否有报错
    get isCreditCardFormError() {
      return Object.values(self.creditCardValid).some((value: any) => value !== "");
    },
    get creditBankType() {
      const first: string = (self.creditCardForm.cardNo as any)?.[0] || "";
      const res = BNP_BANK_STR;
      switch (first) {
        case BNP_BANK_TYPE.VISA:
          return BNP_BANK_STR.VISA;
        case BNP_BANK_TYPE.MASTER_CARD:
          return BNP_BANK_STR.MASTER_CARD;
        default:
          return BNP_BANK_STR.DEFAULT;
      }
    },
  }))
  .actions(withSetPropAction)
  .actions((self: any) => ({
    setIsPayNow(data: boolean) {
      self.isPayNow = data;
    },
    // 设置信用卡表单
    setCreditCardForm(data: typeof ICreditCardVo) {
      self.creditCardForm = data;
      self.bnpCreditCardSubmitForm = {
        ...self.bnpCreditCardSubmitForm,
        number: (data as any).cardNo,
        expiryDate: (data as any).expireDateYear + (data as any).expireDateMonth,
        securityCode: (data as any).cvv,
      };
    },
    // 设置信用卡表单验证
    setCreditCardValid(data: typeof ICreditCardVo) {
      self.creditCardValid = data;
    },
    // 设置bnp信用卡提交表单
    setBnpCreditCardSubmitForm(data: typeof IBnpCreditCardVo) {
      self.bnpCreditCardSubmitForm = data;
    },

    // 处理表单失焦事件
    handleBlur(e: any, field: string) {
      let value = e?.target?.value || (self.creditCardForm as any)[field]; // 替换空格
      value = value.replace(/\s/g, "");
      let valid: any = "";
      switch (field) {
        case "cardNo":
          valid = validateCardNo(value);
          break;
        case "expireDateMonth":
        case "expireDateYear":
          const res: any = {
            ...self.creditCardForm,
            [field]: value,
          };
          valid = validateExpiryDate(
            {
              year: res.expireDateYear,
              month: res.expireDateMonth,
            },
            field,
          );
          break;
        case "cvv":
          valid = validateCVV(value);
          break;
        default:
          break;
      }

      if (Object.prototype.toString.call(valid) === "[object String]") {
        self.creditCardValid = {
          ...self.creditCardValid,
          [field]: valid,
        };
      } else {
        self.creditCardValid = {
          ...self.creditCardValid,
          ...valid,
        };
      }

      return valid;
    },

    // 处理表单选中事件
    handleFocus(e: any, field: string) {
      self.creditCardValid = {
        ...self.creditCardValid,
        [field]: "",
      };
    },

    // 提交验证表单
    validateForm() {
      let res: any = {};

      Object.keys(self.creditCardForm).map((field: string) => {
        const valid: any = self.handleBlur(undefined, field);
        if (Object.prototype.toString.call(valid) === "[object String]") {
          res[field] = valid;
        } else {
          res = {
            ...res,
            ...valid,
          };
        }
      });

      return Object.values(res).every((v) => !v);
    },

    // 设置账单地址
    setBillingAddress(data: any) {
      self.billingAddress = data || {};
    },
    initCreditForm() {
      const initData: any = {
        cardNo: "",
        expireDateMonth: "",
        expireDateYear: "",
        cvv: "",
      };
      self.creditCardForm = { ...initData };
      self.creditCardValid = { ...initData };
    },
  }));

export interface CreditCardStoreModel extends Instance<typeof CreditCardStoreModel> {}
